module.exports = __webpack_public_path__ + "static/media/md-heart-dislike.aaeb7a8f.svg";